import './Card.css';
import React from 'react';

type Props = {
    // Props for the ConnectionView component
    children: JSX.Element | JSX.Element[] | string | string[],
}

const Card: React.FC<Props> = ({ children }: Props) => {
    return <div className="card">{children}</div>
};

export default Card;